import { AxiosResponse } from "axios";
import { useMutation, useQuery } from "react-query";

import { MainUrl } from "core/data/main-url";
import { IAxiosResult } from "../../models/axios-result.model";
import methods from "../interceptors/http.interceptor";
import {
  TCreateNewOrder,
  TGetCurrentUserOrdersParams,
} from "core/models/order.model";

const url = `${MainUrl}/api/store/Order`;

const CreateNewOrder = async (
  params: TCreateNewOrder
): Promise<AxiosResponse<IAxiosResult>> => {
  return await methods.post(`${url}/CreateNewOrder`, params);
};

const GetCurrentUserOrders = async (
  params: TGetCurrentUserOrdersParams
): Promise<AxiosResponse<IAxiosResult>> => {
  return await methods.post(`${url}/GetCurrentUserOrders`, params);
};

const GetCurrentUserOrderDetails = async (
  orderId: number
): Promise<AxiosResponse<IAxiosResult>> => {
  return await methods.get(`${url}/GetCurrentUserOrderDetails/${orderId}`);
};

//----------------------------------------------------------------------------------------

export const useCreateNewOrder = () => useMutation(CreateNewOrder, {});

export const useGetCurrentUserOrders = (params: TGetCurrentUserOrdersParams) =>
  useQuery(["GetCurrentUserOrders", params], () =>
    GetCurrentUserOrders(params)
  );

export const useGetCurrentUserOrderDetails = (orderId: number) =>
  useQuery(
    ["GetCurrentUserOrderDetails", orderId],
    () => GetCurrentUserOrderDetails(orderId),
    { enabled: !!orderId }
  );
